import { GetManagementInvitationDetailsResponse, OAuthClientTokens } from "@givenwell/management-api";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { api, auth } from "./utils";

export const MOCK_INVITE_SUPPORTER_TOKEN =
  "GIVENWELL_MAGIC_STRING_MOCK_INVITE_SUPPORTER_1FAEFB6177B4672DEE07F9D3AFC62588CCD2631EDCF22E8CCC1FB35B501C9C86";

export const MOCK_INVITE_SUPPLIER_TOKEN =
  "GIVENWELL_MAGIC_STRING_MOCK_INVITE_SUPPLIER_1FAEFB6177B4672DEE07F9D3AFC62588CCD2631EDCF22E8CCC1FB35B501C9C86";

const mockSupporterInvitationDetailsResponse = {
  email: "wren@aviator.co.nz",
  family_name: "Pounamu",
  given_name: "Wren",
  organisation_name: "Aviator NZ",
  invitation_type: "supporter",
  applicable_terms: [],
} satisfies GetManagementInvitationDetailsResponse;
const mockSupplierInvitationDetailsResponse = {
  email: "wren@aviator.co.nz",
  family_name: "Pounamu",
  given_name: "Wren",
  organisation_name: "Aviator NZ",
  invitation_type: "supplier",
  applicable_terms: [],
} satisfies GetManagementInvitationDetailsResponse;
const mockOAuthClientTokens = {
  access_token: "c",
  expires_in: 1,
  id_token: "a",
  refresh_token: "b",
} satisfies OAuthClientTokens;

export const invitationDetailsQuery = (token?: string) =>
  queryOptions({
    queryKey: ["invitation-details", token],
    queryFn: async () => {
      if (token === MOCK_INVITE_SUPPORTER_TOKEN) {
        return mockSupporterInvitationDetailsResponse;
      }
      if (token === MOCK_INVITE_SUPPLIER_TOKEN) {
        return mockSupplierInvitationDetailsResponse;
      }
      const response = await api.invitation.getManagementInvitationDetails({ invitationToken: token! });
      return response;
    },
    enabled: !!token,
    retry: 2,
  });

export function useAcceptManagementInvitationMutation() {
  return useMutation({
    mutationFn: async (args: { token: string; password: string; termsIds: string[] }) => {
      if (!args.token || !args.password) {
        throw new Error("Missing required fields");
      }

      if (args.token === MOCK_INVITE_SUPPORTER_TOKEN || args.token === MOCK_INVITE_SUPPLIER_TOKEN) {
        return mockOAuthClientTokens;
      }
      const data = await api.invitation.acceptManagementInvitation({
        invitationToken: args.token,
        requestBody: { password: args.password, terms_ids: args.termsIds },
      });
      auth.saveAuthTokens(data);
      return data;
    },
  });
}

export function useResendManagementInvitationMutation() {
  return useMutation({
    mutationFn: async (args: { token: string }) => {
      if (!args.token) {
        throw new Error("Missing token");
      }

      return await api.invitation.resendManagementInvitation({ invitationToken: args.token });
    },
  });
}
